(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  const initializeAnnouncementCountdowns = (scope = document) => {
    scope.querySelectorAll('[data-announcement-countdown]').forEach((countdown) => {
      if (countdown.dataset.countdownInitialized === 'true') return;

      const deadline = Date.parse(countdown.dataset.countdownDeadline);
      if (Number.isNaN(deadline)) return;

      const days = countdown.querySelector('[data-countdown-days]');
      const hours = countdown.querySelector('[data-countdown-hours]');
      const minutes = countdown.querySelector('[data-countdown-minutes]');
      const seconds = countdown.querySelector('[data-countdown-seconds]');

      const update = () => {
        const remaining = deadline - Date.now();
        if (remaining <= 0) {
          countdown.hidden = true;
          if (countdown.dataset.countdownHideOnExpiry === 'true') {
            const utilityBar = countdown.closest('.utility-bar');
            if (utilityBar) utilityBar.hidden = true;
          }
          window.clearInterval(countdown.countdownInterval);
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        days.textContent = String(Math.floor(totalSeconds / 86400));
        hours.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
        minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
        countdown.setAttribute(
          'aria-label',
          countdown.dataset.countdownLabel + ' ' + days.textContent + 'd ' + hours.textContent + 'h ' + minutes.textContent + 'm ' + seconds.textContent + 's'
        );
        countdown.hidden = false;
      };

      countdown.dataset.countdownInitialized = 'true';
      update();
      countdown.countdownInterval = window.setInterval(update, 1000);
    });
  };

  initializeAnnouncementCountdowns();
  document.addEventListener('shopify:section:load', (event) => initializeAnnouncementCountdowns(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-announcement-countdown]').forEach((countdown) => {
      window.clearInterval(countdown.countdownInterval);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catpip-pdp-closing-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('catpip-closing-purchase')) {
    customElements.define(
      'catpip-closing-purchase',
      class CatpipClosingPurchase extends HTMLElement {
        connectedCallback() {
          this.price = this.querySelector('[data-catpip-close-price]');
          this.handlePurchaseState = ({ detail }) => {
            if (detail?.effectivePriceWithCurrency && this.price) {
              this.price.textContent = detail.effectivePriceWithCurrency;
            }
          };
          document.addEventListener('catpip:purchase-state-change', this.handlePurchaseState);
        }

        disconnectedCallback() {
          document.removeEventListener('catpip:purchase-state-change', this.handlePurchaseState);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catpip-pdp-offerbar"] && !Shopify.designMode) return;
  try {
    
    class CatpipCountdown extends HTMLElement {
      connectedCallback() {
        this.end = new Date(this.dataset.end.replace(' ', 'T')).getTime();
        this.render();
        this.timer = setInterval(() => this.render(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      render() {
        if (isNaN(this.end)) { this.textContent = ''; return; }
        let diff = this.end - Date.now();
        if (diff <= 0) {
          clearInterval(this.timer);
          this.closest('.catpip-offerbar')?.classList.add('catpip-offerbar--ended');
          this.textContent = '';
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor(diff / 3600000) % 24;
        const m = Math.floor(diff / 60000) % 60;
        const s = Math.floor(diff / 1000) % 60;
        const pad = (n) => String(n).padStart(2, '0');
        const parts = [];
        if (d > 0) parts.push(`<b>${d}</b>d`);
        parts.push(`<b>${pad(h)}</b>h`, `<b>${pad(m)}</b>m`, `<b>${pad(s)}</b>s`);
        this.innerHTML = parts.join(' ');
      }
    }
    if (!customElements.get('catpip-countdown')) customElements.define('catpip-countdown', CatpipCountdown);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
